import { useState, useEffect } from 'react';
import { sn, fmt$, fmt$0 } from '../utils/formatters';
import { fmtDateShort } from '../utils/dateRange';
import { supabase } from '../lib/supabase';
import Modal from './Modal';
import IngredientForm from './IngredientForm';

export default function IngredientInspect({ig,ings,batches,mi,orgId,t,onClose,onEdit,onSwap,onDuplicate,onDelete,onNavTo,save,setIngs,settings,si,sb,mn:mnProp}){
const[history,setHistory]=useState(null);
const[showCCs,setShowCCs]=useState(false);
const[showBatches,setShowBatches]=useState(false);
const[editing,setEditing]=useState(false);

useEffect(()=>{
  if(!ig?.id)return;
  supabase.from('price_history').select('id,old_price,new_price,changed_at,source').eq('ingredient_id',ig.id).order('changed_at',{ascending:false}).limit(5)
    .then(({data})=>setHistory(data||[]));
},[ig?.id]);

// Recipe references
const ccRefs=(mi||[]).filter(m=>m.r.some(l=>l.i===ig.id));
const batchRefs=(batches||[]).filter(b=>b.r.some(l=>l.i===ig.id));

const mn="'DM Mono',monospace";
const lbl={fontSize:9,color:t.td,textTransform:'uppercase',marginBottom:2};
const val={fontSize:13,fontWeight:500};

return(
<Modal open={true} onClose={onClose} width={520} zIndex={35} t={t}>
<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
<div style={{display:'flex',alignItems:'center',gap:10}}>
<div style={{fontSize:18,fontWeight:700}}>{sn(ig.n)}</div>
<span style={{fontSize:10,padding:'2px 8px',borderRadius:4,background:'rgba(59,130,246,0.1)',color:t.bl}}>{ig.cat||'—'}</span>
</div>
<button onClick={onClose} style={{background:'none',border:'none',color:t.tm,fontSize:18,cursor:'pointer',padding:4}}>✕</button>
</div>

<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
<div><div style={lbl}>Brand</div><div style={val}>{ig.b||'—'}</div></div>
<div><div style={lbl}>Distributor</div><div style={val}>{ig.dist||'—'}</div></div>
<div><div style={lbl}>Category</div><div style={val}>{ig.cat||'—'}</div></div>
<div><div style={lbl}>Expense Category</div><div style={val}>{ig.ec||'Food'}</div></div>
<div><div style={lbl}>Case Price</div><div style={{...val,fontFamily:mn}}>${fmt$0(ig.cp||0)}</div></div>
<div><div style={lbl}>Case Qty</div><div style={{...val,fontFamily:mn}}>{ig.cq||1} {ig.cu}</div></div>
<div><div style={lbl}>Pack Type</div><div style={val}>{ig.pt||'—'}</div></div>
<div><div style={lbl}>Unit</div><div style={val}>{ig.cu||'EACH'}</div></div>
<div><div style={lbl}>Vendor Item #</div><div style={{...val,fontFamily:mn}}>{ig.vin||'—'}</div></div>
<div><div style={lbl}>Par Level</div><div style={{...val,fontFamily:mn}}>{ig.par||'—'}</div></div>
<div><div style={lbl}>Location</div><div style={val}>{ig.loc||'—'}</div></div>
<div><div style={lbl}>Last Updated</div><div style={val}>{ig.updatedAt?fmtDateShort(ig.updatedAt.split('T')[0]):'—'}</div></div>
</div>

<div style={{background:t.sf,borderRadius:8,padding:'10px 14px',marginBottom:16,fontSize:12}}>
<span style={{fontWeight:600}}>Used in </span>
<span onClick={ccRefs.length?()=>setShowCCs(p=>!p):undefined} style={{color:ccRefs.length>0?t.yl:t.td,cursor:ccRefs.length?'pointer':'default',borderBottom:ccRefs.length?`1px dashed ${t.yl}`:'none'}}>{ccRefs.length} cost card{ccRefs.length!==1?'s':''}</span>
<span style={{color:t.td}}> and </span>
<span onClick={batchRefs.length?()=>setShowBatches(p=>!p):undefined} style={{color:batchRefs.length>0?t.bl:t.td,cursor:batchRefs.length?'pointer':'default',borderBottom:batchRefs.length?`1px dashed ${t.bl}`:'none'}}>{batchRefs.length} batch{batchRefs.length!==1?'es':''}</span>
{showCCs&&ccRefs.length>0&&<div style={{marginTop:8,borderTop:`1px solid ${t.bd}`,paddingTop:6}}>
{ccRefs.map(m=><div key={m.id} onClick={()=>{if(onNavTo){onClose();onNavTo('costcards',m.id);}}} style={{padding:'4px 0',fontSize:11,color:onNavTo?t.yl:t.td,cursor:onNavTo?'pointer':'default',fontWeight:500,textDecoration:onNavTo?'underline':'none'}}>{m.n}</div>)}
</div>}
{showBatches&&batchRefs.length>0&&<div style={{marginTop:8,borderTop:`1px solid ${t.bd}`,paddingTop:6}}>
{batchRefs.map(b=><div key={b.id} onClick={()=>{if(onNavTo){onClose();onNavTo('batches',b.id);}}} style={{padding:'4px 0',fontSize:11,color:onNavTo?t.bl:t.td,cursor:onNavTo?'pointer':'default',fontWeight:500,textDecoration:onNavTo?'underline':'none'}}>{b.n}</div>)}
</div>}
</div>

<div style={{marginBottom:16}}>
<div style={{fontSize:11,fontWeight:600,marginBottom:6}}>Recent Price History</div>
{history===null?<div style={{fontSize:11,color:t.td}}>Loading...</div>:
history.length===0?<div style={{fontSize:11,color:t.td,fontStyle:'italic'}}>No price changes recorded.</div>:
<div style={{border:`1px solid ${t.bd}`,borderRadius:6,overflow:'hidden'}}>
{history.map(h=>{const up=h.new_price>h.old_price;return(
<div key={h.id} style={{display:'flex',alignItems:'center',gap:10,padding:'6px 10px',borderBottom:`1px solid ${t.bd}`,fontSize:11}}>
<span style={{color:t.td,width:70}}>{new Date(h.changed_at).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'2-digit'})}</span>
<span style={{fontFamily:mn,color:t.td}}>${fmt$(h.old_price)}</span>
<span style={{color:t.td}}>→</span>
<span style={{fontFamily:mn,fontWeight:600,color:up?t.ac:t.gn}}>${fmt$(h.new_price)}</span>
<span style={{fontSize:9,padding:'1px 5px',borderRadius:3,background:h.source==='invoice'?'rgba(59,130,246,0.1)':'rgba(139,143,158,0.1)',color:h.source==='invoice'?t.bl:t.td}}>{h.source}</span>
</div>);})}
</div>}
</div>

<div style={{display:'flex',justifyContent:'space-between',alignItems:'center',borderTop:`1px solid ${t.bd}`,paddingTop:12}}>
<div style={{display:'flex',gap:12,alignItems:'center'}}>
{(save&&setIngs)?<button onClick={()=>setEditing(true)} style={{background:'none',border:'none',color:t.bl,cursor:'pointer',fontSize:12,fontWeight:500,padding:0,fontFamily:"'DM Sans',sans-serif"}}>Edit</button>:onEdit&&<button onClick={()=>{onClose();onEdit(ig);}} style={{background:'none',border:'none',color:t.bl,cursor:'pointer',fontSize:12,fontWeight:500,padding:0,fontFamily:"'DM Sans',sans-serif"}}>Edit →</button>}
{onSwap&&<button onClick={()=>{onClose();onSwap(ig);}} style={{background:'none',border:'none',color:t.yl,cursor:'pointer',fontSize:12,fontWeight:500,padding:0,fontFamily:"'DM Sans',sans-serif"}}>Swap →</button>}
{onDuplicate&&<button onClick={()=>{onClose();onDuplicate(ig);}} style={{background:'none',border:'none',color:t.tm,cursor:'pointer',fontSize:12,fontWeight:500,padding:0,fontFamily:"'DM Sans',sans-serif"}}>Duplicate →</button>}
{onDelete&&<button onClick={()=>{onClose();onDelete(ig);}} style={{background:'none',border:'none',color:t.ac,cursor:'pointer',fontSize:12,fontWeight:500,padding:0,fontFamily:"'DM Sans',sans-serif"}}>Delete →</button>}
</div>
<button onClick={onClose} style={{background:t.sf,border:`1px solid ${t.bd}`,borderRadius:6,padding:'6px 16px',fontSize:11,cursor:'pointer',color:t.tm,fontFamily:"'DM Sans',sans-serif"}}>Close</button>
</div>
{editing&&<Modal open={true} onClose={()=>setEditing(false)} width={680} zIndex={40} t={t}>
<div style={{marginBottom:12}}>
<div style={{fontSize:16,fontWeight:700}}>Edit Ingredient</div>
<div style={{fontSize:12,color:t.td,marginTop:2}}>{ig.n} — {ig.b||''}</div>
</div>
<IngredientForm mode="edit" initial={ig} onSave={(data)=>{
  const ppc=parseFloat(data.ppc)||1,spp=parseFloat(data.spp)||0;
  data.cq=ppc*spp;
  if(Math.abs((ig.cp||0)-(data.cp||0))>0.01&&save?.logPriceChange){save.logPriceChange(orgId,null,ig.id,ig.cp,data.cp,'manual');}
  setIngs(p=>p.map(i=>i.id===ig.id?{...i,...data,prevCp:i.cp!==data.cp?i.cp:i.prevCp,updatedAt:new Date().toISOString()}:i));
  save.updateIngredient(ig.id,data);
  setEditing(false);
}} onCancel={()=>setEditing(false)} categories={ings?[...new Set(ings.map(i=>i.cat))].sort():[]} vendors={settings?.vendors?.sort()||[]} t={t} si={si} sb={sb} mn={mnProp}/>
</Modal>}
</Modal>);
}
